module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_fails.js
// module id = 28
// module chunks = 1